// Firebase app singleton + App Check bootstrap.
// Ports the vanilla _initAppCheck() pattern from public/app/index.html L128.

import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  type AppCheck,
} from 'firebase/app-check'
import { env } from '../../env'

function createApp(): FirebaseApp {
  if (getApps().length > 0) return getApps()[0]!
  return initializeApp(env.firebase)
}

export const firebaseApp = createApp()

// Activate App Check exactly once. Fire-and-forget.
// If reCAPTCHA fails (network, bad key, origin not allowlisted), we log and keep going —
// Firestore rules will still guard writes. Vanilla does the same (try/catch at L128).
let _appCheck: AppCheck | null = null
export function initAppCheck(): AppCheck | null {
  if (_appCheck) return _appCheck
  try {
    _appCheck = initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(env.recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    })
    return _appCheck
  } catch (e) {
    console.warn('[appcheck] activation failed (continuing without):', e)
    return null
  }
}
